import type { AppDispatch } from '@/store/store';
import { logout } from '@/features/auth/authSlice';
import { resetGlobalLoading } from '@/features/ui/uiLoadingSlice';
import { clearAuthStorage } from './clearAuthStorage';

export function forceLogout(dispatch?: AppDispatch, redirectTo = '/auth/login') {
  try {
    dispatch?.(logout());
    dispatch?.(resetGlobalLoading());
  } catch {}

  try {
    clearAuthStorage();
  } catch {}

  if (typeof window !== 'undefined') {
    window.location.href = redirectTo;
  }
}
